import React, { useEffect } from "react";
import { useState } from "react";
import { ListarHistoricoUAUController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { HistoricoClienteInterface } from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import SpinnerUAU from "../../../Loding/SpinnerUAU";
import ComponenteHistorico from "../ComponenteHistorico";

interface IComponenteHistoricoUAUProps {
    ID_CHAVE_ERP: string;
    height?: number;
}

export default function ComponenteHistoricoUAU(
    props: IComponenteHistoricoUAUProps
) {
    const [loading, setLoading] = useState(false);
    const [lstHistoricoUAU, setLstHistoricoUAU] = useState<
        Array<HistoricoClienteInterface>
    >([]);

    useEffect(() => {
        setLoading(true);
        ListarHistoricoUAUController(props.ID_CHAVE_ERP)
            .then((res) => {
                setLstHistoricoUAU(
                    res.map((historico) => ({
                        DS_TIPO_CASO: "UAU",
                        DS_ETAPA_TIPO_CASO: historico.STATUS_ATENDIMENTO,
                        DS_USUARIO: historico.USUARIO_RESPONSAVEL,
                        DS_HISTORICO: historico.DESCRICAO,
                        ID_CASO: historico.NUMERO_ATENDIMENTO,
                        DT_CADASTRO: historico.DATA_ATENDIMENTO,
                    }))
                );
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false);
            });
    }, [props.ID_CHAVE_ERP]);

    return !loading ? (
        <ComponenteHistorico
            historico={lstHistoricoUAU}
            height={props.height}
        />
    ) : (
        <SpinnerUAU />
    );
}
